export const BOOKING_TOOLTIP_MAX_LENGTH = 40;
export type BookingFormType = 'private' | 'legal' | 'promoter';
export const BookingFormType = {
  Private: 'private' as BookingFormType,
  Legal: 'legal' as BookingFormType,
  Promoter: 'promoter' as BookingFormType
};
